/**
 * FolderColorStrip — a 4px coloured strip that lives on the left edge of an entity
 * card. Hovers grow to 6px and the whole thing acts as a "filter by this folder"
 * shortcut when clicked.
 *
 * The host card must be `position: relative` and have enough left padding for the
 * strip not to overlap content (pl-2 / pl-3 is plenty).
 *
 * Props:
 *   entityId   — for the testid
 *   folderId   — current folder_id on the entity (may be null/undefined)
 *   folders    — array of {id, name, color} for the entity type
 *   onFilter   — (folderId) => void; called when strip is clicked
 *   testIdPrefix — e.g. "npc", "item", "lore" → produces "npc-folder-strip-{entityId}"
 */
export const FolderColorStrip = ({ entityId, folderId, folders, onFilter, testIdPrefix }) => {
  if (!folderId || !folders?.length) return null;
  const folder = folders.find(f => f.id === folderId);
  const color = folder?.color;
  if (!color) return null;
  return (
    <button
      type="button"
      aria-label={`Filter by ${folder.name}`}
      onClick={(e) => { e.stopPropagation(); onFilter?.(folderId); }}
      onMouseDown={(e) => e.stopPropagation()}
      className="absolute left-0 top-0 bottom-0 w-1 hover:w-1.5 transition-all cursor-pointer z-10"
      style={{ backgroundColor: color }}
      title={`Filter: ${folder.name}`}
      data-testid={`${testIdPrefix}-folder-strip-${entityId}`}
    />
  );
};

export default FolderColorStrip;
